import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CountBadge',
  props: {
    type: { default: 'primary' },
    count: null
  },
  setup(__props: any) {

const props = __props as { type: 'primary' | 'secondary', count: number };



const countText = computed(() => {
  return props.count > 9 ? '9+' : props.count
})

return { __sfc: true,props, countText }
}

})